/* eslint-disable no-unused-vars */
import { covid19CallCenterDown } from './covid19';

// TODO: Potentially get content from G-TagManage
export default '';
